import { Link } from "gatsby";
import React, { useState } from "react";
import { PopupButton } from "@typeform/embed-react";
import SubscribePopup from "../subscribe";

const Button = ({
  btnText,
  btnLink,
  downloadLink,
  onClose,
  small = false,
  m = "",
  btnType = "primary",
  height = "h-[50px] md:h-[58px]",
  linkType = "internalLink",
  borderSide = "left",
  fontSize = "text-sm",
  spacing = "sm:tracking-[2px]",
  formId = "pCocsLbQ",
}) => {
  const [open, setOpen] = useState(false);

  function handleTypeformClick() {
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "request_reservation",
      });
    }
  }

  function handleButtonClick(label, url) {
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "btn_click",
        label: label,
        url: url,
      });
    }
  }
  if (linkType === "internalLink") {
    return (
      <Link to={btnLink}>
        <Btn
          btnText={btnText}
          small={small}
          m={m}
          btnType={btnType}
          height={height}
          borderSide={borderSide}
          fontSize={fontSize}
          spacing={spacing}
        />
      </Link>
    );
  } else if (linkType === "externalLink") {
    return (
      <a
        href={btnLink}
        target={"_blank"}
        onClick={() => handleButtonClick(btnText, btnLink)}
      >
        <Btn
          btnText={btnText}
          small={small}
          m={m}
          btnType={btnType}
          height={height}
          borderSide={borderSide}
          fontSize={fontSize}
          spacing={spacing}
          btnLink={btnLink}
        />
      </a>
    );
  } else if (linkType === "subscribeAndDownload") {
    return (
      <div>
        <button
          onClick={() => setOpen(true)}
          className={`inline-block cursor-pointer px-[30px] ${height} ${fontSize} leading-[38px] font-extrabold uppercase ${
            borderSide === "left"
              ? "rounded-tl-[27px] rounded-br-[27px]"
              : " rounded-bl-[27px] rounded-tr-[27px]"
          }
          text-center no-underline whitespace-nowrap bg-white ${
            btnType === "primary" ? "btn-primary" : "btn-secondary"
          }  border border-solid ${spacing}
            box-border transition-all duration-200 ease-linear  
            ${!small && "mb-[10px]"} ${!small && "w-full"} ${m}`}
          aria-label={btnText}
        >
          {btnText}
        </button>
        {open && (
          <SubscribePopup
            onClose={() => setOpen(false)}
            url={downloadLink}
            popUpClose={onClose}
          />
        )}
      </div>
    );
  } else {
    return (
      <button onClick={handleTypeformClick} className="appearance-none">
        <PopupButton
          id={formId}
          className={`inline-block cursor-pointer px-[30px] ${height} ${fontSize} leading-[38px] font-extrabold uppercase ${
            borderSide === "left"
              ? "rounded-tl-[27px] rounded-br-[27px]"
              : " rounded-bl-[27px] rounded-tr-[27px]"
          }
          text-center no-underline whitespace-nowrap bg-white ${
            btnType === "primary" ? "btn-primary" : "btn-secondary"
          }  border border-solid 
            box-border transition-all duration-200 ease-linear ${spacing}
            ${!small && "mb-[10px]"} ${!small && "w-full"} ${m}`}
        >
          {btnText}
        </PopupButton>
      </button>
    );
  }
};

const Btn = ({
  btnText,
  small,
  m,
  btnType,
  height,
  borderSide,
  fontSize,
  spacing,
  btnLink,
}) => {
  return (
    <button
      className={`inline-block cursor-pointer px-[30px] ${height} ${fontSize} leading-[38px] font-extrabold uppercase ${
        borderSide === "left"
          ? "rounded-tl-[27px] rounded-br-[27px]"
          : " rounded-bl-[27px] rounded-tr-[27px]"
      }
         text-center no-underline whitespace-nowrap bg-white ${
           btnType === "primary" ? "btn-primary" : "btn-secondary"
         }  border border-solid ${spacing}
          box-border transition-all duration-200 ease-linear  
         ${!small && "mb-[10px]"} ${!small && "w-full"} ${m}`}
      aria-label={btnText}
    >
      {btnText}
    </button>
  );
};

export default Button;
